module.exports = __webpack_public_path__ + "static/media/line_pattern.fragment.b008ac61.glsl";